const STORAGE_PREFIX = 'byway.tripReprice:';

const TRIP_REPRICE_MAX_WAIT_MS = 20_000;
export const TRIP_REPRICE_POLL_MS = 2_000;

export const tripRepriceKey = (tripId: string) => ['tripReprice', tripId];

export const markTripRepriceStarted = (tripId: string) => {
  globalThis.sessionStorage?.setItem(`${STORAGE_PREFIX}${tripId}`, String(Date.now()));
};

export const clearTripRepriceStarted = (tripId: string) => {
  globalThis.sessionStorage?.removeItem(`${STORAGE_PREFIX}${tripId}`);
};

export const isTripRepriceInProgress = (tripId: string) => {
  if (!tripId) return false;

  const startedAt = Number(globalThis.sessionStorage?.getItem(`${STORAGE_PREFIX}${tripId}`));
  if (!startedAt) return false;
  if (Date.now() - startedAt < TRIP_REPRICE_MAX_WAIT_MS) return true;

  clearTripRepriceStarted(tripId);
  return false;
};
